import React from 'react'
import './footer.css'
const footer = () => {
  return (

            <footer className="footer">Privacy Policy</footer>


  )
}

export default footer
